import { constructFrom as r } from "./constructFrom.js";
function e(t, o) {
  return r(o || t, t);
}
export {
  e as default,
  e as toDate
};
